import { ChangeEvent } from 'react';
import { Field } from 'formik';

import { Input } from '@@/form-components/Input';
import { ItemProps } from '@@/form-components/InputList';

import { MatchLabel } from './types';

export function MatchLabelsItem({
  item,
  onChange,
  disabled,
  readOnly,
  index,
}: ItemProps<MatchLabel>) {
  return (
    <div className="flex items-center gap-2">
      <Field
        as={Input}
        value={item.key}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange({ ...item, key: e.target.value })
        }
        name={`networkSecurityRuleLabels[${index}].key`}
        placeholder="e.g. portainer.io/tier"
        disabled={disabled}
        readOnly={readOnly}
        className="w-1/2"
        data-cy="kubernetes-network-security-rule-pod-selection-label-key-input"
      />
      <Field
        as={Input}
        value={item.value}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange({ ...item, value: e.target.value })
        }
        name={`networkSecurityRuleLabels[${index}].value`}
        placeholder="value"
        disabled={disabled}
        readOnly={readOnly}
        className="w-1/2"
        data-cy="kubernetes-network-security-rule-pod-selection-label-value-input"
      />
    </div>
  );
}
